import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const ServicesSection = () => {
  const services = [{
    title: 'Auto Wrappen',
    description: 'Transformeer uw auto met premium wraps en bescherm de originele lak met onze professionele wrapping service.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vPa5oULwHDcYzvNDCacQ1D/how-long-does-vinyl-wrap-last-1200x800-1-768x512.jpg',
    alt: 'Auto wrapping service - Professionele montage van vinyl wrap',
    price: '€1.250',
    link: '/diensten/autowrappen'
  }, {
    title: 'Ramen Tinten',
    description: 'Privacy en UV-bescherming met stijl. Hoogwaardige tinting voor een luxe uitstraling en optimaal comfort.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wNLF8ocqa3iPQaSqTR3jq1/carwindowtintingfranklintn-768x512.jpg',
    alt: 'Ramen tinten service - Vakkundige installatie van premium raamfolie',
    price: 'Vanaf €175',
    link: '/diensten/ramen-tinting'
  }, {
    title: 'Lichten Smoken',
    description: 'Geef uw auto een unieke, krachtige look met professioneel getinte lichten terwijl de originele lichtsterkte behouden blijft.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7Sz73Ji6DM6jfsjFgLE8Pn/G22-CSL-Red-768x511.webp',
    alt: 'Lichten smoken service - BMW met stijlvolle gerookte achterlichten',
    price: 'Vanaf €130',
    link: '/diensten/lichten-smoken'
  }, {
    title: 'Ontchromen',
    description: 'Verwijder chrome elementen voor een cleane, moderne look die uw auto direct onderscheidt van de massa.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8h8EqFfY6iTr2pX1pd2aXy/AS_Dechrome_Hero-768x512.jpg',
    alt: 'Ontchromen service - Matte zwarte auto met volledige chrome delete',
    price: '€349',
    link: '/diensten/ontchromen'
  }];
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  // Track which slide is active based on scroll position
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const handleScroll = () => {
      const slideWidth = el.clientWidth;
      const newIndex = Math.round(el.scrollLeft / slideWidth);
      setActiveIndex(newIndex);
    };
    el.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToIndex = (index: number) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTo({
      left: el.clientWidth * index,
      behavior: 'smooth'
    });
  };
  const handlePrev = () => {
    const newIndex = Math.max(0, activeIndex - 1);
    scrollToIndex(newIndex);
  };
  const handleNext = () => {
    const newIndex = Math.min(services.length - 1, activeIndex + 1);
    scrollToIndex(newIndex);
  };
  const renderServiceCard = (service: (typeof services)[number], index: number) => <Link key={index} to={service.link} className="group flex flex-col h-full bg-[#111111] overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300" data-id="element-550" data-mp="293mayr24ymxt">
      <div className="relative w-full" style={{
      paddingBottom: '56.25%'
    }} data-id="element-551" data-mp="1zcrlzexi998o">
        <img src={service.imageUrl} alt={service.alt} className="absolute inset-0 w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-500 ease-out" decoding="async" data-id="element-552" data-mp="1uc3nk86y5q4f" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-553" data-mp="1gfqg7rw4n53o"></div>
      </div>
      <div className="p-5" data-id="element-554" data-mp="3fqrkqmkm6suc">
        <h3 className="text-xl font-bold text-white mb-2" data-id="element-555" data-mp="3asgawbubkic4">{service.title}</h3>
        <p className="text-[#CCCCCC] mb-4 text-sm" data-id="element-556" data-mp="3aqdbx2b6vev9">{service.description}</p>
        <div className="inline-flex items-center text-white text-sm" data-id="element-557" data-mp="28gczbgofj5n3">
          <span className="mr-2" data-id="element-558" data-mp="2cgwysqwh6lce">Meer informatie</span>
          <ArrowRightIcon size={14} data-id="element-559" data-mp="2cej3cgxvv74b" />
        </div>
      </div>
    </Link>;
  return <section id="services" className="bg-[#0a0a0a] py-20" data-id="element-560" data-mp="1ygm8boz2v8rr">
      <div className="max-w-7xl mx-auto px-4 lg:px-6" data-id="element-561" data-mp="23f5t3m1xqeij">
        <div className="text-center mb-12" data-id="element-562" data-mp="23hs09kkwys08">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-563" data-mp="1oqsyotihx3q5">
            Onze <span className="text-[#D6281F]" data-id="element-564" data-mp="1thj3o5n0f4kb">Diensten</span>
          </h2>
          <p className="text-[#CCCCCC] max-w-2xl mx-auto text-base" data-id="element-565" data-mp="1tjm1vcybg404">
            Premium car styling en customization door ervaren specialisten voor
            een unieke uitstraling.
          </p>
        </div>

        {/* Desktop Grid */}
        <div className="hidden md:grid grid-cols-2 gap-6" data-id="element-566" data-mp="15rx2jcn2uf9o">
          {services.map((service, index) => renderServiceCard(service, index))}
        </div>

        {/* Mobile Carousel */}
        <div className="md:hidden relative" data-id="element-567" data-mp="r4yelrnfi2zp">
          <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide -mx-4 px-4" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-568" data-mp="r5ro30drv6lj">
            {services.map((service, index) => <div key={index} className="flex-shrink-0 w-full snap-center pr-4 last:pr-0" data-id="element-569" data-mp="w6nrzdy4isqy" data-mpi={index}>
                {renderServiceCard(service, index)}
              </div>)}
          </div>

          {/* Carousel Controls */}
          <div className="flex items-center justify-between mt-6 px-1" data-id="element-570" data-mp="1jtnifyfvcmf5">
            <button onClick={handlePrev} disabled={activeIndex === 0} aria-label="Vorige dienst" className="w-10 h-10 rounded-full bg-[#121212] border border-[#333] flex items-center justify-center text-white disabled:opacity-30 active:bg-[#1a1a1a] transition-opacity" data-id="element-571" data-mp="1euspi3o6thhb">
              <ChevronLeftIcon size={18} data-id="element-572" data-mp="1vy9l4d1dt54u" />
            </button>

            {/* Dot indicators */}
            <div className="flex items-center gap-2" data-id="element-573" data-mp="20vsyzbu63fw9">
              {services.map((_, index) => <button key={index} onClick={() => scrollToIndex(index)} aria-label={`Ga naar dienst ${index + 1}`} className={`transition-all duration-300 rounded-full ${activeIndex === index ? 'w-6 h-2 bg-[#D6281F]' : 'w-2 h-2 bg-white/30'}`} data-id="element-574" data-mp="25tb7j149vt3q" data-mpi={index} />)}
            </div>

            <button onClick={handleNext} disabled={activeIndex === services.length - 1} aria-label="Volgende dienst" className="w-10 h-10 rounded-full bg-[#121212] border border-[#333] flex items-center justify-center text-white disabled:opacity-30 active:bg-[#1a1a1a] transition-opacity" data-id="element-575" data-mp="2om5dj5jx4avt">
              <ChevronRightIcon size={18} data-id="element-576" data-mp="rmelvy018e1s" />
            </button>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-577" data-mp="mvyaejfrv2i2">
          <Link to="/contact" className="inline-flex items-center bg-[#0f0f0f] border border-[#333] hover:bg-[#161616] text-white px-6 py-3 transition-colors duration-300 text-sm font-medium" data-id="element-578" data-mp="mv6c30usiqo3">
            <span className="mr-2" data-id="element-579" data-mp="cvnu2pyfxeyo">Persoonlijk advies nodig?</span>
            <ArrowRightIcon size={16} data-id="element-580" data-mp="1akhe0lnvmr3t" />
          </Link>
        </div>
      </div>
    </section>;
};